import { Link } from "react-router-dom";

export function LoginWallCard(props: {
  title?: string;
  body?: string;
  compact?: boolean;
}) {
  return (
    <div className={`login-wall-card${props.compact ? " compact" : ""}`}>
      <div className="section-heading">
        <p className="eyebrow">Dartmouth Login</p>
        <h2>{props.title ?? "Log in to view reviews and ratings"}</h2>
      </div>
      <p className="auth-copy">
        {props.body ?? "Create an account or log in with your Dartmouth email to view reviews, rate courses, and write your own."}
      </p>
      <div className="hero-actions">
        <Link to="/login/" className="primary-link">
          Log in
        </Link>
        <Link to="/signup/" className="secondary-link">
          Create account
        </Link>
      </div>
    </div>
  );
}
